import type { PlanSignupIntent } from './planCheckout';
import {
  buildLoginPathWithIntent,
  buildRegisterPathWithMode,
  buildVerifyEmailPath,
} from './planCheckout';
import { sanitizeReturnUrl } from './urlValidation';

export const BRIDGE_RETURN_URL_STORAGE_KEY = 'sp_bridge_return_url';

const readSessionStorage = (): Storage | null => {
  if (typeof window === 'undefined') return null;
  return window.sessionStorage;
};

/** Persiste return_url sanitizado no sessionStorage. No-op se inválido. */
export const saveBridgeReturnUrl = (raw: string | null | undefined): void => {
  const sanitized = sanitizeReturnUrl(raw);
  if (!sanitized) return;

  const storage = readSessionStorage();
  if (!storage) return;
  storage.setItem(BRIDGE_RETURN_URL_STORAGE_KEY, sanitized);
};

/** Lê return_url do sessionStorage (revalida na leitura). */
export const getBridgeReturnUrl = (): string | null => {
  const storage = readSessionStorage();
  if (!storage) return null;

  const raw = storage.getItem(BRIDGE_RETURN_URL_STORAGE_KEY);
  const sanitized = sanitizeReturnUrl(raw);
  if (!sanitized) {
    if (raw) storage.removeItem(BRIDGE_RETURN_URL_STORAGE_KEY);
    return null;
  }
  return sanitized;
};

export const clearBridgeReturnUrl = (): void => {
  const storage = readSessionStorage();
  if (!storage) return;
  storage.removeItem(BRIDGE_RETURN_URL_STORAGE_KEY);
};

const appendReturnUrlParam = (path: string, returnUrl: string | null): string => {
  const sanitized = sanitizeReturnUrl(returnUrl);
  if (!sanitized) return path;

  const [pathname, search = ''] = path.split('?');
  const params = new URLSearchParams(search);
  params.set('return_url', sanitized);
  const query = params.toString();
  return query ? `${pathname}?${query}` : pathname;
};

export const buildLoginPathWithReturnUrl = (
  returnUrl: string | null,
  intent?: Partial<PlanSignupIntent> | null,
  options?: { activated?: boolean }
): string => appendReturnUrlParam(buildLoginPathWithIntent(intent, options), returnUrl);

export const buildRegisterPathWithReturnUrl = (
  returnUrl: string | null,
  intent: PlanSignupIntent
): string => appendReturnUrlParam(buildRegisterPathWithMode(intent), returnUrl);

export const buildVerifyEmailPathWithReturnUrl = (
  email: string,
  intent: PlanSignupIntent,
  returnUrl: string | null
): string => appendReturnUrlParam(buildVerifyEmailPath(email, intent), returnUrl);
